export default {
  items: [],
  newKey: null,
  loading: false,
};
